import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import {
  RequestIndexes,
  SuccessIndexes,
  FailureIndexes,
  RequestMailGatewayLogs,
  SuccessMailGatewayLogs,
  FailureMailGatewayLogs,
  RequestPefDevices,
  SuccessPefDevices,
  FailurePefDevices,
  RequestPefLogs,
  SuccessPefLogs,
  FailurePefLogs,
  RequestDashboardData,
  SuccessDashboardData,
  FailureDashboardData,
  RequestDashboardHealth,
  SuccessDashboardHealth,
  FailureDashboardHealth,
} from "../actions/zsearchActions";

import axiosApi from "../../utils/axios";
import { getAlertsFromDashboardData, viewerTimeZone } from "../../Pages/MailGateway/util";

export function* indexes({ payload: index }) {
  try {
    const response = yield call(axiosApi.get, `/api/search/zsearch2/index_name?name=${index}`);
    if (response.data?.[0]?.host === "mg" && response.data?.[0]?.pid === 10) {
      yield put(FailureIndexes(index));
    } else {
      const mappedData = response?.data?.map((item) => ({
        id: item,
        value: item?.split(".")?.[1],
      }));
      yield put(SuccessIndexes({ indexes: mappedData, index }));
    }
  } catch (e) {
    console.log(index, e);
    yield put(FailureIndexes(index));
  }
}

export function* mailGatewayLogs({ payload }) {
  const { index, size, timeRange, keyword, process } = payload;
  try {
    let stype = "s";
    if (typeof keyword === "string" && keyword.length === 0) {
      stype = "match_all";
    } else if (keyword === null) {
      stype = "match_all";
    } else {
      stype = "match";
    }
    const response = yield call(axiosApi.post, `/api/search/zsearch2/${index}`, {
      max_results: size,
      query: { term: keyword, start_time: timeRange, end_time: new Date().toISOString() },
      search_type: stype,
      //query: {
      //  bool: {
      //    must: [
      //      { match_phrase: { "log.process": process } },
      //      keyword ? { wildcard: { _all: `*${keyword}*` } } : { match_all: {} },
      //    ],
      //    filter: timeRange
      //      ? [
      //          {
      //            range: {
      //              "@timestamp": {
      //                gte: timeRange, // Start time
      //                lte: new Date().toISOString(), // End time (current time)
      //              },
      //            },
      //          },
      //        ]
      //      : [],
      //  },
      //},
      //size: size,
    });
    yield put(SuccessMailGatewayLogs(response.data));
  } catch (e) {
    yield put(FailureMailGatewayLogs());
  }
}

export function* pefDevices({ payload: index }) {
  const now = new Date();
  const twoHoursBefore = new Date(now.getTime() - 2 * 60 * 60 * 1000);
  try {
    const response = yield call(axiosApi.post, `/api/search/zsearch2/${index}`, {
      query: { start_time: twoHoursBefore.toISOString(), end_time: now.toISOString() },
      aggs: {
        tags: {
          agg_type: "term",
          field: "tag",
          size: 10,
        },
      },
    });
    const mappedData =
      response.data?.tags?.buckets.map((item) => ({ id: item.key, value: item.key })) || [];
    yield put(SuccessPefDevices(mappedData));
  } catch (e) {
    yield put(FailurePefDevices());
  }
}

export function* pefLogs({ payload }) {
  const { index, size, timeRange, keyword, device } = payload;
  try {
    let stype = "s";
    if (typeof keyword === "string" && keyword.length === 0) {
      stype = "match_all";
    } else if (keyword === null) {
      stype = "match_all";
    } else {
      stype = "match";
    }
    const response = yield call(axiosApi.post, `/api/search/zsearch2/${index}`, {
      max_results: size,
      query: { term: keyword, start_time: timeRange, end_time: new Date().toISOString() },
      search_type: stype,
      //query: {
      //  bool: {
      //    must: [
      //      { match_phrase: { tag: device } },
      //      keyword ? { wildcard: { _all: `*${keyword}*` } } : { match_all: {} },
      //    ],
      //    filter: timeRange
      //      ? [
      //          {
      //            range: {
      //              "@timestamp": {
      //                gte: timeRange, // Start time
      //                lte: new Date().toISOString(), // End time (current time)
      //              },
      //            },
      //          },
      //        ]
      //      : [],
      //  },
      //},
      //size: size,
    });
    yield put(SuccessPefLogs(response.data.filter((item) => item["@tag"] === device)));
  } catch (e) {
    yield put(FailurePefLogs());
  }
}

// Delivery summary aggregated by the backend; postfix log lines are never sent to the browser
export function* dashboardData({ payload: host }) {
  try {
    const response = yield call(
      axiosApi.get,
      `/api/mail-gateway/dashboard-traffic/${host.replace("postfix.", "")}`,
      { params: { tz: viewerTimeZone() } },
    );
    const dashboardData = response.data;
    const dashboardAlerts = getAlertsFromDashboardData(dashboardData);
    yield put(SuccessDashboardData({ dashboardData, dashboardAlerts }));
  } catch (e) {
    yield put(FailureDashboardData());
  }
}

export function* dashboardHealth({ payload: index }) {
  try {
    const response = yield call(axiosApi.get, `/api/containers/mailhealth/${index.split(".")[1]}`);
    yield put(SuccessDashboardHealth(response.data));
  } catch (e) {
    yield put(FailureDashboardHealth());
  }
}

const zsearchSagas = [
  takeEvery(RequestIndexes, indexes),
  takeLatest(RequestMailGatewayLogs, mailGatewayLogs),
  takeLatest(RequestPefDevices, pefDevices),
  takeLatest(RequestPefLogs, pefLogs),
  takeLatest(RequestDashboardData, dashboardData),
  takeLatest(RequestDashboardHealth, dashboardHealth),
];

export default zsearchSagas;
